import { formatHistoryAt } from "../../lib/mkRules";
import type { BoardBrief } from "../../types/contract";

interface BriefCardProps {
  brief: BoardBrief | null;
  refreshing: boolean;
  onRefresh: () => void;
}

/** 施策画面 v2 の最上段: AIブリーフ（見出し1行＋要点最大4行）。⟳ で再生成（実行中は二重押し防止）。 */
export function BriefCard({ brief, refreshing, onRefresh }: BriefCardProps) {
  return (
    <section className="mk2-brief" aria-label="AIブリーフ">
      <div className="mk2-brief-label">AIブリーフ</div>
      {brief ? (
        <>
          <h2 className="mk2-brief-head">{brief.headline}</h2>
          {brief.lines.length > 0 && (
            <ul className="mk2-brief-lines">
              {brief.lines.slice(0, 4).map((line, i) => (
                <li key={i}>{line}</li>
              ))}
            </ul>
          )}
        </>
      ) : (
        <p className="mk2-brief-empty">AIの要約はまだありません</p>
      )}
      <div className="mk2-brief-foot">
        {brief && <span className="mk2-brief-at">{formatHistoryAt(brief.generated_at)} 更新</span>}
        {brief?.model === "rules" && <span className="mk2-tag">ルール要約</span>}
        {brief?.stale && <span className="mk2-tag mk2-tag-warn">更新待ち</span>}
        <button
          type="button"
          className="mk2-icon-btn"
          onClick={onRefresh}
          disabled={refreshing}
          aria-label="AIブリーフを更新"
          title="AIブリーフを更新"
        >
          <span className={refreshing ? "mk2-spin" : undefined} aria-hidden="true">
            ⟳
          </span>
        </button>
      </div>
    </section>
  );
}
